export enum TeamJoinProcess {
    ANYONE = 1,
    INVITE = 2,
    APPROVAL = 3,
  }